<script>
  import { getContext, onMount } from "svelte";
  import {
    Map,
    Marker,
    Geocoder,
    contextKey,
    controls,
  } from "@beyonk/svelte-mapbox";
  const { GeolocateControl, NavigationControl, ScaleControl } = controls;
  let mapComponent;

  import MapScripting from "./MapScripting.svelte";
  import MapExpand from "./MapExpand.svelte";
  import CampusMarker from "./CampusMarker.svelte";


  export let expanded = null;
  export let zoom = 16.75;
  let showMarkers = false;

  $: if(expanded !== null){
    if(mapComponent){
      mapComponent.resize();
    }

    if(expanded){
      showMarkers = true;
    } else {
      showMarkers = false;
    }
  }
</script>

<div class="map">
<Map
  accessToken="pk.eyJ1IjoiemRiLSIsImEiOiJjazd3dTh6d2cwNDVqM2ZtazRhYzh0NjMzIn0.kEWM1FnfWEnlRu6pyxDOmw"
  style="mapbox://styles/zdb-/ckqa4rkqo6wwk18rzl6o05he9"
  zoom={zoom}
  bind:this={mapComponent}
  on:recentre={(e) => console.log(e.detail.center)}
  options={{
    pitch: 100,
    bearing: 0,
    center: [-80.182,35.865],
  }}
>

  <CampusMarker 
    text={'Go to Davie Campus'} 
    goto={[-80.55452737468636, 35.87128390079509]} 
    lng={-80.18497236542873} 
    lat={35.86553271903074} 
    iconPosition={'up'} 
    rotation={-18} 
    iconRotation={-145}
    show={showMarkers}
  />

  <CampusMarker 
    text={'Go to Davidson Campus'} 
    goto={[-80.182,35.865]} 
    lng={-80.55455706947001} 
    lat={35.86974734578449} 
    iconPosition={'down'} 
    rotation={-18} 
    iconRotation={45}
    show={showMarkers}
  />

  <!-- <NavigationControl /> -->
  <!-- <GeolocateControl /> -->
  <!-- <ScaleControl /> -->

  <MapScripting
    buildingColor="#f05640"
    buildingHoverColor="#fff"
    buildingBgColor="#f05640"
    popupBgColor="#002a55"
  />
</Map>
</div>

<style>
:global(.map canvas) {
  width: 100% !important;
  height: 100% !important;
}
</style>
